module.exports = __webpack_public_path__ + "img/20180402_160151-min.7efc73b0.jpg";